import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Building, Meridian } from '../models';

@Injectable()
/**
 * @requires
 */
export class BuildingOpeningHoursFormService {

  formGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
  ) {
    this.initForm();
  }

  areDaysValid(): boolean {
    const days = this.formGroup.get('openingDays') as FormArray;
    for (const day of days.controls) {
      if (day.invalid) {
        return false;
      }
    }

    return true;
  }

  getFormFromModel(building: Building): FormGroup {
    this.initForm();

    for (let i = 1; i <= 7; i++) {
      const modelDay = building.getOpeningDay(i);
      const formDay = this.createEmptyDay();

      formDay.patchValue({isOpen: modelDay.isOpen});

      if (modelDay.isOpen) {
        const amHours = modelDay.getHoursByMeridian(Meridian.am);
        const pmHours = modelDay.getHoursByMeridian(Meridian.pm);
        formDay.patchValue({amStart: amHours.periodStart});
        formDay.patchValue({amEnd: amHours.periodEnd});
        formDay.patchValue({pmStart: pmHours.periodStart});
        formDay.patchValue({pmEnd: pmHours.periodEnd});
      }

      (this.formGroup.get('openingDays') as FormArray).push(formDay);
    }

    return this.formGroup;
  }

  getModelFromForm(formGroup: FormGroup, building: Building): Building {
    for (let i = 1; i <= 7; i++) {
      const modelDay = building.getOpeningDay(i);

      if (modelDay.isOpen === true) {
        const amHours = modelDay.getHoursByMeridian(Meridian.am);
        const pmHours = modelDay.getHoursByMeridian(Meridian.pm);
        const formDay = (formGroup.get('openingDays') as FormArray).controls[i - 1];
        pmHours.periodStart = formDay.get('pmStart').value;
        pmHours.periodEnd = formDay.get('pmEnd').value;
        amHours.periodStart = formDay.get('amStart').value;
        amHours.periodEnd = formDay.get('amEnd').value;
      }
    }

    return building;
  }

  private createEmptyDay() {
    return this.formBuilder.group({
      isOpen: ['', Validators.required],
      amStart: [''],
      amEnd: [''],
      pmStart: [''],
      pmEnd: [''],
    }, {
      validators: this.hoursConflict,
    });
  }

  private hoursConflict: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const amStart = control.get('amStart').value;
    const amEnd = control.get('amEnd').value;
    const pmStart = control.get('pmStart').value;
    const pmEnd = control.get('pmEnd').value;

    if (moment(amStart).isAfter(amEnd)) {
      return {hoursConflict: true};
    } else if (moment(pmStart).isAfter(pmEnd)) {
      return {hoursConflict: true};
    } else if (moment(amEnd).isAfter(pmStart)) {
      return {hoursConflict: true};
    }

    return null;
  };

  private initForm() {
    this.formGroup = this.formBuilder.group({
      openingDays: this.formBuilder.array([]),
    });
  }
}
